/* tslint:disable:no-bitwise */

// Not actually a secure hashing function but more like a low collision, fast hashing function
export class HashUtility {
    public static toHash(input: string): number {
        let hash = 0;
        let i: number;
        let chr: number;
        if (input.length === 0) {
            return hash;
        }
        for (i = 0; i < input.length; i++) {
            chr   = input.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
}
